import { ActivityIndicator } from 'react-native';

const Loader = ({
  size = 'small',
  color,
}: {
  size?: number | 'small' | 'large';
  color?: string;
}) => {
  return <ActivityIndicator size={size} color={color} />;
};

export default Loader;
